import Hidden from '@material-ui/core/Hidden';
import React from 'react';
import useInitialWidth from '../../../hooks/useInitialWidth';
import useSelectActiveUserProfile from '../../../hooks/useSelectActiveUserProfile';
import BottomNav from './components/BottomNav';
import ConnectedAccountDrawer from './components/ConnectedAccountDrawer';
import TopNav from './components/TopNav';

type Props = {
  viewName?: string;
};

const AccountNav = (props: Props) => {
  const { viewName } = props;
  const initialWidth = useInitialWidth();
  const userProfile = useSelectActiveUserProfile();

  return (
    <>
      <Hidden initialWidth={initialWidth} smDown>
        <TopNav userProfile={userProfile} viewName={viewName} />
      </Hidden>

      <Hidden initialWidth={initialWidth} mdUp>
        <BottomNav viewName={viewName} />
      </Hidden>

      <ConnectedAccountDrawer />
    </>
  );
};

export default AccountNav;
